import { c as _c } from "react/compiler-runtime";
import usePut from '../../../hooks/usePut';
export const NOT_APPLICABLE_DATAFIELD_CODE = {
  personalProjects: 'user_personal_projects',
  professionalExperiences: 'user_professional_experiences',
  socialLinks: 'user_social_links'
} as const;
export type NotApplicableDatafieldCode = (typeof NOT_APPLICABLE_DATAFIELD_CODE)[keyof typeof NOT_APPLICABLE_DATAFIELD_CODE];
const DATAFIELD_DECLARATION_ROUTE = '/users/:userId/datafield-declarations/:datafieldName' as const;
interface UseDeclareDatafieldNotApplicableParams {
  userId: number;
  context: string;
  datafieldCode: NotApplicableDatafieldCode;
}
export function useDeclareDatafieldNotApplicable(t0) {
  const $ = _c(9);
  const {
    userId,
    context,
    datafieldCode
  } = t0;
  let t1;
  if ($[0] !== datafieldCode || $[1] !== userId) {
    t1 = {
      userId,
      datafieldName: datafieldCode
    };
    $[0] = datafieldCode;
    $[1] = userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== context) {
    t2 = {
      "X-Request-Context": context
    };
    $[3] = context;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["profileCompletion"];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = {
      routeParams: t1,
      headers: t2,
      queryKeysToInvalidate: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return usePut(DATAFIELD_DECLARATION_ROUTE, t4);
}